import NoSearchResultIcon from './NoSearchResultIcon'

export default NoSearchResultIcon
